import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div
          className="min-h-screen flex items-center justify-center px-6 py-16"
          style={{ background: "#070b14" }}
          data-testid="error-boundary-fallback"
        >
          <div className="max-w-lg text-center">
            <div className="mx-auto mb-8 w-32 h-[5px] rounded-full bg-gradient-to-r from-[#55a2d2] via-[#af3fa6] to-[#dda632]" />
            <div className="eyebrow mb-5">Something went sideways</div>
            <h1 className="font-display text-5xl text-[#f5ecd9] leading-[0.98]">
              Let's <span className="rainbow-text">try that again.</span>
            </h1>
            <p className="mt-6 text-lg text-[#a8b2cc]">
              Our end hit an unexpected error. A quick refresh usually puts things right.
              If it keeps happening, please let us know at{" "}
              <a href="mailto:info@infinity-dms.co.za" className="underline hover:text-[#af3fa6]">
                info@infinity-dms.co.za
              </a>.
            </p>
            <button
              onClick={this.handleReload}
              className="btn-primary mt-8"
              data-testid="error-boundary-reload"
            >
              Refresh the page
            </button>
            {process.env.NODE_ENV !== "production" && this.state.error && (
              <pre className="mt-8 text-xs text-left text-[#a8b2cc] bg-[#141e32]/60 rounded-xl p-4 overflow-auto max-h-40">
                {String(this.state.error.stack || this.state.error)}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
